import { isObject } from 'underscore';
import { IncorrectTypeError } from './incorrect-type-error';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

export function assertIsCustomReactOption<
  T = string,
  U = string | number,
  V = { label?: string; value?: string | number },
>(obj: unknown): asserts obj is TReactSelectOption<T, U, V> {
  if (!isObject(obj)) {
    throw new IncorrectTypeError(`Object required, received ${JSON.stringify(obj)}`);
  }

  if (!('value' in obj) || !('label' in obj)) {
    throw new IncorrectTypeError(`Custom React Select option required, received ${JSON.stringify(obj)}`);
  }

  if (typeof obj.value !== 'string' && typeof obj.value !== 'number') {
    throw new IncorrectTypeError(`Custom React Select option value must be a string, received ${JSON.stringify(obj)}`);
  }

  if (typeof obj.label !== 'string') {
    throw new IncorrectTypeError(`Custom React Select option label must be a string, received ${JSON.stringify(obj)}`);
  }
}
